import * as React from "react";
import ReactTable from "react-table";
import { FiltroPeriodosMora, PeriodoMora } from "../modelo/AdminPeriodosMora";

export default class TablaPeriodosMora extends React.Component<TablaPeriodosMoraProps, any> {

    columns = [{
        id: "aseguradora",
        Header: "Aseguradora",
        accessor: "aseguradora",
        Cell: props => (this.renderTexto(props)),
        width: 220
    }, {
        id: "tipoDocumento",
        Header: "Tipo Documento",
        accessor: "tipoDocumento",
        Cell: props => (this.renderTexto(props)),
        width: 220
    }, {
        id: "numeroDocumento",
        Header: "Numero Documento",
        accessor: "numeroDocumento",
        Cell: props => (this.renderTexto(props)),
        width: 220
    }, {
        id: "consecutivoNIT",
        Header: "Cons NIT",
        accessor: "consecutivoNIT",
        Cell: props => (this.renderTexto(props)),
        width: 220
    }, {
        id: "periodoMora",
        Header: "Periodo Mora",
        accessor: "periodoMora",
        Cell: props => (this.renderTexto(props)),
        width: 220
    }
    ];

    render() {
        const { periodos, paginas, tamanoPagina, paginaActual } = this.props;
        let numRegistros = 0;

        if (periodos.length < tamanoPagina) {
            numRegistros = periodos.length;
        } else {
            numRegistros = tamanoPagina;
        }
        return (
            <div className={"panel panel-success"}>
                <div className={"panel-heading"}>
                    <h2 className={"panel-title-white"}>
                        <span className="badge">{periodos.length}</span> Periodos en Mora
                    </h2>
                </div>
                <ReactTable data={periodos}
                    columns={this.columns}
                    manual
                    defaultPageSize={numRegistros}
                    pageSizeOptions={this.calcularOpciones(numRegistros)}
                    page={paginaActual}
                    sortable={false}
                    resizable={false}
                    previousText={"Anterior"}
                    nextText={"Siguiente"}
                    loadingText={"Cargando..."}
                    noDataText={"No se ha encontrado información."}
                    pageText={"Página"}
                    ofText={"de"}
                    rowsText={""}
                    className={"-highlight -striped"}
                    pages={paginas}
                    onPageChange={(pageIndex) => {
                        this.consultarCambioPagina(tamanoPagina, pageIndex, tamanoPagina);
                    }}
                    onPageSizeChange={(pageSize, pageIndex) => {
                        this.consultarCambioPagina(pageSize, pageIndex, tamanoPagina);
                    }}
                />
            </div>
        );
    }

    consultarCambioPagina(pageSize: number, pageIndex: number, tamanoPagina: number) {
        const filtroDocumento: FiltroPeriodosMora = {
            numeroPoliza: this.props.filtro.numeroPoliza,
            tipoDocumento: this.props.filtro.tipoDocumento,
            documento: this.props.filtro.documento,
            consecutivoNIT: this.props.filtro.consecutivoNIT,
            tamanoPagina: pageSize ? pageSize : tamanoPagina,
            paginaActual: pageIndex,
        };
        this.props.consultaPaginada(filtroDocumento);
    }

    calcularOpciones(tamanoPagina: number) {
        const arreglo = [10, 20, 25, 50, 100];
        const elemento = arreglo.find(valor => valor === tamanoPagina);
        if (elemento) {
            return arreglo;
        } else {
            return [...arreglo, tamanoPagina].sort((a, b) => { return a - b; });
        }
    }

    renderTexto = (props: any) => {
        if (props.value) {
            return (
                <div style={{ marginTop: '10px' }}>
                    <span>{props.value}</span>
                </div>
            );
        }
        return (props.value);
    }
}

interface TablaPeriodosMoraProps {
    periodos: Array<PeriodoMora>,
    filtro: FiltroPeriodosMora,
    paginas: number,
    tamanoPagina: number,
    paginaActual: number,
    consultaPaginada?: (filtro: FiltroPeriodosMora) => void;
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/periodos_mora/componentes/TablaPeriodosMora.tsx